/**
 * Whether the development tools are shown.
 *
 * They are on automatically when the server runs with `ALLOW_DEV_AUTH=1`, and can be turned on
 * against any server by loading the app once with `?devtools=1`. The choice is remembered so
 * the flag does not have to be carried through every navigation, and `?devtools=0` clears it.
 */

/** Storage key of the remembered preference. */
const STORAGE_KEY = 'anwesenheit.devtools';

/** Query parameter that turns the tools on or off. */
const QUERY_PARAM = 'devtools';

/**
 * Resolves whether to show the development tools, consuming the query parameter if present.
 *
 * @param devAuth true when the server accepts development authentication.
 */
export function devToolsEnabled(devAuth: boolean): boolean {
  const requested = new URLSearchParams(globalThis.location?.search ?? '').get(QUERY_PARAM);
  if (requested === '1') globalThis.localStorage?.setItem(STORAGE_KEY, '1');
  if (requested === '0') globalThis.localStorage?.removeItem(STORAGE_KEY);
  return devAuth || globalThis.localStorage?.getItem(STORAGE_KEY) === '1';
}
